<button (click)="closeClick()" type="button" [attr.aria-label]="'form.mobile-menu.close.button.aria-label' | translate" [attr.data-test]="testId() || null">
    <app-icon icon="x-mark" [size]="16" />
</button>
